import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import fetchAPI from "./fetchAPI";
import { GlobalStateClass } from '../common/interfaces/globalStateClass';
import {
    getProfileSettingForDevelopmentMode, determineCultureFormat
} from '../common/timeLiveFunction';
import {
    getAccountFeature,getTimeEntryHoursFormat
} from '../common/timesheetFunction';
import { GetCalendarStartDay } from "./GetCalendayStartDay";
import fetchIntegrationAPI from "./fetchIntegrationAPI";
const { NODE_ENV } = process.env
declare const chrome: any;

const initialState: GlobalStateClass = {
    isLoading: false,
    showAdminPages: false,
    pageId: '',
    menuList: [],
    customMenuList: [],
    IsList: false,
    IsAdd: false,
    IsEdit: false,
    IsDelete: false,
    accountPreferenceList: [],
    manageTerminologyList: [],
    status: 'idle',
    maxMenuHeight: 180,
    //Level
    sessionAccountId: 0,
    accountRoleId: 0,
    sessionAccountEmployeeId: 0,
    CurrentCultureDateFormat: '',
    accessToken: '',
    employeeName: '',
    shortName: '',
    customFieldsTemplate: [],
    //Preferences
    accountPreferencesId: 0,
    accountName: '',
    emailAddress: '',
    subDomain: '',
    countryId: 0,
    country: '',
    timeZoneId: 0,
    timeZoneName: '',
    address1: '',
    address2: '',
    zipCode: '',
    city: '',
    telephone: '',
    fax: '',
    isEmailSubscription: false,
    lockSubmittedRecords: false,
    lockApprovedRecords: false,
    isShowElectronicSign: false,
    enableUploadFeature: false,
    showAdditionalDepartmentInformationInEmployee: false,
    isShowEmployeeNameWithCode: false,
    isShowDisableEmployeesInReport: false,
    restrictEntryWithinTaskDateRange: false,
    scheduledEmailSendTime: '',
    accountSessionTimeout: 0,
    decimalPlaces: 0,
    pageSize: 0,
    fromEmailAddressDisplayName: '',
    fromEmailAddress: '',
    userInterfaceLanguage: '',
    showEmployeeNameBy: 0,
    isCompanyOwnLogo: false,
    employeeSegregationType: 0,
    showProjectNameInInvoiceReport: false,
    showBillingRateInInvoiceReport: false,
    showEntryDateInInvoiceReport: false,
    showEmployeeNameInInvoiceReport: false,
    showWorkTypeInInvoiceDescription: false,
    roundOffValueInInvoice: false,
    resetInvoiceNo: false,
    invoiceNoPrefix: '',
    invoiceBillingTypeId: '',
    invoiceFooter: '',
    showProjectNameInTask: false,
    showClientNameInTask: false,
    insertDefaultTaskNameInProject: '',
    defaultTaskName: '',
    isAutoCompleteTask: false,
    allocationHoursInProjectTaskTeam: false,
    sortTaskBy: '',
    autoGenerateProjectCode: false,
    allocationHoursInProjectTeam: false,
    accountIdsForAllocationHours: false,
    enableGanttChart: false,
    showCompletedProjectInProjectList: false,
    showClientDepartmentInProject: false,
    includeCurrentYearInProjectCode: false,
    automaticallyIncludeAdminitratorInProjectTeam: false,
    showDisableProjectInReport: false,
    isProjectTemplateMandatory: false,
    projectCodePrefix: '',
    showAdditionalProjectInformationType: 0,
    showTimeOffInTimesheet: false,
    showProjectForTimeOff: false,
    hideTimeOffHoursInformation: false,
    isShowTimeOffInDays: false,
    isShowTimeOffPoliciesInDays: false,
    isTimeOffStatusEditMode: false,
    showTimeOffTypesBy: '',
    showClientInExpenseSheet: false,
    showTaskInExpenseSheet: false,
    expenseApprovalTypeBy: '',
    expenseSheetPrintFooter: '',
    showClockStartEnd: false,
    showClientInTimesheet: false,
    isAllowOverlappingTimeEntries: false,
    showDescriptionInWeekView: false,
    showCompletedProjectsInTimeSheet: false,
    showCompletedTasksInTimeSheet: false,
    showWorkTypeInTimeSheet: false,
    showCostCenterInTimeSheet: false,
    isCostCenterMandatory: false,
    showCopyTimesheetButton: false,
    showCopyActivitiesButtonInTimesheet: false,
    enableOfflineTimesheet: false,
    enableTimerInTimesheet: false,
    showPercentageInTimesheet: false,
    calculateTaskPercentageAutomatically: false,
    defaultProjectTaskSelectionInTimesheet: false,
    autoResizeTimesheet: false,
    numberOfBlankRowsInTimeEntry: 0,
    numberOfBlankRowsInTimeOff: 0,
    timesheetOverduePeriods: 0,
    showClockStartEndBy: '',
    timeEntryHoursFormatId: '',
    timeEntryFormat: '',
    showAdditionalTaskInformationType: 0,
    defaultTimeEntryMode: '',
    timesheetSort: '',
    showCostCenterInTimesheetBy: '',
    timesheetApprovalTypeBy: '',
    timesheetPrintFooter: '',
    timesheetSubmissionMessage: '',
    enableGoogleAuthentication: false,
    enablePasswordComplexity: false,
    passwordExpiryPeriod: 0,
    enableSingleSignOnSSO: false,
    usingSingleSignOnWith: '',
    sAMLSSOURL: '',
    remoteLogoutURL: '',
    x509Certificate: '',
    showFilterInformationOnExport: false,
    cultureInfoName: '',
    currencySymbol: '',
    version: '',
    accountBaseCurrencyId: 0,
    accountReimbursementCurrencyId: 0,
    showEmployeeProfilePicture: false,
    googleAppsDomain: '',
    showProjectInTimesheet: false,
    defaultCurrencyId: 0,
    systemTimeEntryHoursFormat: '',
    profilePictureColor: '#512DA8',
    //profilePictureColor
    //Time Entry Description Required:
    //Show "ShowAll" in Approval Popup:
    accountFeatureList: [],
    masterAccountRoleId: 0,
    decimalFormat: false,
    hoursPerDay: 8,
    employeeNameWithCode: "",
    assignTimeOffPolicyIn: 0,
    assignWorkingDayTypeIn: 0,
    isEmailVerified: false,
    dateInsertionFormat: "YYYY-MM-DD",
    customFieldInsertionFormat: "YYYY-MM-DD HH:mm:ss.SSS",
    allowZeroHoursInTimesheet: false,
    isGoogleCalendarAutoSync: false,
    isGoogleCalendarTaskAutoSync: false,
    isGoogleCalendarTimesheetAutoSync: false,
    isGoogleCalendarTaskManualSync: false,
    isGoogleCalendarTimesheetManualSync: false,
    isOutlookCalendarAutoSync: false,
    isOutlookCalendarTaskAutoSync: false,
    isOutlookCalendarTimesheetAutoSync: false,
    isOutlookCalendarTaskManualSync: false,
    isOutlookCalendarTimesheetManualSync: false,
    showTemplateInTimesheet: false,
    showMyProfile: false,
    profileURL: "",
    showSubMenus: false,
    currentPopupId: null,
    AccountIdsForGoogleCalendar: false,
    AccountIdsForOutlookCalendar: false,
    allowMoveTask: false,
    reviewurl: "",
    HighlightTimeEntriesBy: "",
    calendarStartDay: 1,
    pageSizeTeam:10,
    IsEmployeeList: false,
    IsEmployeeAdd: false,
    IsEmployeeEdit: false,
    IsEmployeeDelete: false,
    notificationEvents: [],
    ProfileTimeZoneIANA: "UTC",
    AccountEmployeeDashboardId: 0,
    licenseActivationList: [],
    selectedRecord: {},
    isValidLicenseActivation: false,
    expiryDateLicense: "",
    isFreeAccount: false,
    rowscount: 0,
    numberOfUsersAllowed: 0,
    DISABLE_LICENSE: "",
    applicationMode: "",
    isFreeLiteVersion: false,
    isPaidCustomerLicenseExpired: false,
    isHostedPaidCustomerLicenseExpired: false,
    cancellationURL: "",
    IsHostedPaidCustomer: false,
    SelectedCurrentHostedPackage: "",
    IsUpgradeExistingPlan: false,
    PackagesData: [],
    OpenInNewTab: false,
    ShowAdvanceBoard: false,
    IsTimesheetApprovalReasonMandatory: false,
    IsTimesheetChangelogEnabled:false
}

interface IThunkApi {
    state: {
        globalState: GlobalStateClass;
    },
}

export const getManageTerminologyList = () => {
    return (dispatch: any, getState: any) => {
        const state = getState().globalState;
        const manageTerminologyList = state.manageTerminologyList;
        if (!manageTerminologyList) {
            // console.error('manageTerminologyList is undefined!');
        }
        // dispatch({
        //     type: 'manageTerminologyList',
        //     payload: manageTerminologyList || []
        // });
        return manageTerminologyList;
    }
}

export const getAccountAdminOptionPages = createAsyncThunk
    <any, void, IThunkApi>
    (
        "PagePermission/v2/getAccountAdminOption",
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchAPI("api/v2/PagePermission/GetAccountAdminOptionPages", "GET", "", true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getPagePermissionsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "PagePermission/v2/getPagePermissions",
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchAPI('api/v2/PagePermission/PagePermissions/' + arg, 'GET', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getParentChildPagePermissionsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "PagePermission/v2/getParentChildPagePermissions",
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const { SystemSecurityCategoryPageId, ChildSystemSecurityCategoryPageIds } = arg;
            const response = await fetchAPI('api/v2/PagePermission/CustomPagePermissions/' + SystemSecurityCategoryPageId + '/' + ChildSystemSecurityCategoryPageIds, 'GET', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getParentPagePermissionsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "PagePermission/v2/getParentPagePermissions",
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchAPI('api/v2/PagePermission/PagePermissions/' + arg, 'GET', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getCustomPagePermissionsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "PagePermission/v2/getCustomPagePermissionsAsync",
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchAPI('api/v2/PagePermission/GetCustomPagePermissions/?value=' + arg, 'GET', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getGlobalAccountPreferenceDataAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'accountPreferences/v2/getGlobalAccountPreferenceData',
        async (arg, thunkApi) => {
            const { accessToken, sessionAccountId, sessionAccountEmployeeId } = thunkApi.getState().globalState
            const response = await fetchAPI(`api/v2/AccountPreferences/getDataAccountPreferenceForm/${sessionAccountId}/${sessionAccountEmployeeId}`, 'Get', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getManageTerminologyAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "ManageTerminology/v2/getManageTerminology",
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchAPI('api/v2/ManageTerminology/TransformedStringFromTerminology', 'GET', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const GetCalendarEventsForNotification = createAsyncThunk
    <any, any, IThunkApi>
    (
        "api/Calendar/GetCalendarEventsForNotification",
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchIntegrationAPI(`api/Calendar/GetCalendarEventsForNotification/${arg}`, 'GET', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getEmployeeProfileSettingAsync = createAsyncThunk(
    'AccountPreferences/getEmployeeProfileSetting',
    async () => {
        if (NODE_ENV === "development") {
            return getProfileSettingForDevelopmentMode();
        }
        const response = await fetchAPI('Services/react.svc/GetUserProfileSetting', 'POST', "", false);
        const json = await response.json();
        return json;
    }
)

// export const getEmployeeMoveToOldAsync = createAsyncThunk
//     <any, any, IThunkApi>
//     (
//         'AccountPreferences/getEmployeeMoveToOldAsync',
//         async (arg, thunkApi) => {
//             // if (NODE_ENV === "development") {
//             //     return getProfileSettingForDevelopmentMode();
//             // }
//             const response = await fetchAPI('Services/react.svc/GetLoginFromReact', 'POST', arg, false);
//             const json = await response.json();
//             return json;
//         }
//     )

export const getAccountFeatureAsync = createAsyncThunk
    <
        any,
        void,
        IThunkApi
    >
    (
        'PagePermission/getAccountFeature',
        async (arg, thunkApi) => {
            const { accountRoleId, accessToken } = thunkApi.getState().globalState;
            const response = await fetchAPI(`api/Account/AccountFeatureAndRole/${accountRoleId}`, 'GET', "", true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const getLicenseActivationAndPageLoadDataAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "LicenseActivation/v2/getLicenseActivationAndPageLoadData",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/LicenseActivation/PageLoad', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

// export const getCustomFieldTemplateByMasterEntityTypeIdAsync = createAsyncThunk
//     <any, any, IThunkApi>
//     (
//         "CustomFields/v2/getCustomFieldTemplateByMasterEntityTypeId",
//         async (arg, thunkApi) => {
//             const { accessToken } = thunkApi.getState().globalState
//             const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/'+arg, 'GET', '', true, accessToken);
//             const json = await response.json();
//             return json;
//         }
//     )

export const globalSlice = createSlice({
    name: 'globalState',
    initialState,
    reducers: {
        checkedshowAdminPagesState: (state) => {
            state.showAdminPages = true;
        },
        UncheckedshowAdminPagesState: (state) => {
            state.showAdminPages = false;
        },
        updatePageIdState: (state, action) => {
            state.pageId = action.payload;
        },

        updateCustomMenuList: (state, action) => {
            state.customMenuList = action.payload;
        },
        updatePageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        updateAllowZeroHoursInTimesheet: (state, action) => {
            state.allowZeroHoursInTimesheet = action.payload;
        },
        updateGoogleCalendarAutoSync: (state, action) => {
            state.isGoogleCalendarAutoSync = action.payload;
        },
        updateOutlookCalendarAutoSync: (state, action) => {
            state.isOutlookCalendarAutoSync = action.payload;
        },
        updateGoogleCalendarTaskAutoSync: (state, action) => {
            state.isGoogleCalendarTaskAutoSync = action.payload;
        },
        updateGoogleCalendarTimesheetAutoSync: (state, action) => {
            state.isGoogleCalendarTimesheetAutoSync = action.payload;
        },
        updateGoogleCalendarTaskManualSync: (state, action) => {
            state.isGoogleCalendarTaskManualSync = action.payload;
        },
        updateGoogleCalendarTimesheetManualSync: (state, action) => {
            state.isGoogleCalendarTimesheetManualSync = action.payload;
        },
        updateOutlookCalendarTaskAutoSync: (state, action) => {
            state.isOutlookCalendarTaskAutoSync = action.payload;
        },
        updateOutlookCalendarTimesheetAutoSync: (state, action) => {
            state.isOutlookCalendarTimesheetAutoSync = action.payload;
        },
        updateOutlookCalendarTaskManualSync: (state, action) => {
            state.isOutlookCalendarTaskManualSync = action.payload;
        },
        updateOutlookCalendarTimesheetManualSync: (state, action) => {
            state.isOutlookCalendarTimesheetManualSync = action.payload;
        },
        updateSubMenusForDisplay: (state, action) => {
            state.showSubMenus = action.payload;
        },
        UpdateCurrentPopupId: (state, action) => {
            state.currentPopupId = action.payload;
        },
        //Open with Login
        updateEmployeeProfileSettingOnDev: (state, action) => {
            if (action.payload) {
                const { AccountEmployeeId, AccountId, AccountRoleId, api_token, first_name, last_name, EmployeeInitials, HoursPerDay, UserInterfaceLanguage, ProfileUrl } = action.payload;

                if (state.sessionAccountEmployeeId == 0) {
                    state.sessionAccountEmployeeId = AccountEmployeeId;
                }
                //state.CurrentCultureDateFormat = CurrentCultureDateFormat;
                state.CurrentCultureDateFormat = determineCultureFormat(UserInterfaceLanguage);
                state.sessionAccountId = AccountId;
                state.accountRoleId = AccountRoleId;
                state.accessToken = api_token;
                state.employeeName = `${first_name} ${last_name}`;
                state.shortName = EmployeeInitials;
                //state.customFieldsTemplate = CustomFieldsTemplate;
                //state.decimalFormat = true;
                state.hoursPerDay = HoursPerDay;
                //state.employeeNameWithCode = "RM";
                localStorage.setItem('accessToken', api_token);
                localStorage.setItem('accountEmployeeId', AccountEmployeeId);
                state.profileURL = ProfileUrl
            }
        },
        setPageId: (state, action) => {
            state.pageId = action.payload; // overwrite with new
        },
        updatePageSizeTeam: (state, action) => {
            state.pageSizeTeam = action.payload;
        },
        UpdateEmployeePermissions: (state, action) => {
            state.IsEmployeeList = action.payload.IsEmployeeList;
            state.IsEmployeeAdd = action.payload.IsEmployeeAdd;
            state.IsEmployeeEdit = action.payload.IsEmployeeEdit;
            state.IsEmployeeDelete = action.payload.IsEmployeeDelete;
        },
        UpdateAccountEmployeeDashboardId: (state, action) => {
           state.AccountEmployeeDashboardId = action.payload; 
        },
        UpdateStateOpenInNewTab: (state, action) => {
           state.OpenInNewTab = action.payload; 
        },
        UpdateStateShowAdvanceBoard: (state, action) => {
           state.ShowAdvanceBoard = action.payload; 
        }
         
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountAdminOptionPages.pending, (state) => {

            })
            .addCase(getAccountAdminOptionPages.fulfilled, (state, { payload }) => {
                state.menuList = payload.data;
            })
            .addCase(getAccountAdminOptionPages.rejected, (state) => {

            })
            .addCase(getPagePermissionsAsync.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPagePermissionsAsync.fulfilled, (state, { payload }) => {
               

                state.IsList = payload.IsList;
                state.IsAdd = payload.IsAdd;
                state.IsEdit = payload.IsEdit;
                state.IsDelete = payload.IsDelete;
                state.isLoading = false;
        

            })
            .addCase(getPagePermissionsAsync.rejected, (state) => {
                state.isLoading = false;
            })

            .addCase(getParentChildPagePermissionsAsync.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getParentChildPagePermissionsAsync.fulfilled, (state, { payload }) => {
                state.IsList = payload.ParentPermission.IsList;
                state.IsAdd = payload.ParentPermission.IsAdd;
                state.IsEdit = payload.ParentPermission.IsEdit;
                state.IsDelete = payload.ParentPermission.IsDelete;
                state.isLoading = false;



            })
            .addCase(getParentChildPagePermissionsAsync.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getParentPagePermissionsAsync.pending, (state) => {

            })
            .addCase(getParentPagePermissionsAsync.fulfilled, (state, { payload }) => {

            })
            .addCase(getParentPagePermissionsAsync.rejected, (state) => {

            })
            .addCase(getCustomPagePermissionsAsync.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getCustomPagePermissionsAsync.fulfilled, (state, { payload }) => {
                state.customMenuList = payload;
                state.isLoading = false;
            })
            .addCase(getCustomPagePermissionsAsync.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getGlobalAccountPreferenceDataAsync.pending, (state) => {

            })
            .addCase(getGlobalAccountPreferenceDataAsync.fulfilled, (state, { payload }) => {
                state.reviewurl = payload.ReviewURI;
                state.accountPreferenceList = payload.data;
                let accountPreferences = payload.data[0];
                state.accountPreferencesId = accountPreferences.AccountPreferencesId;
                state.accountName = accountPreferences.AccountName;
                state.emailAddress = accountPreferences.EMailAddress;
                state.subDomain = accountPreferences.SubDomain;
                state.countryId = accountPreferences.CountryId;
                state.country = accountPreferences.Country;
                state.timeZoneId = accountPreferences.TimeZoneId;
                state.timeZoneName = accountPreferences.TimeZoneName;
                state.address1 = accountPreferences.Address1;
                state.address2 = accountPreferences.Address2;
                state.zipCode = accountPreferences.ZipCode;
                state.city = accountPreferences.City;
                state.telephone = accountPreferences.Telephone;
                state.fax = accountPreferences.Fax;
                state.isEmailSubscription = accountPreferences.IsEmailSubscription;

                state.lockSubmittedRecords = accountPreferences.LockSubmittedRecords;
                state.lockApprovedRecords = accountPreferences.LockApprovedRecords;
                state.isShowElectronicSign = accountPreferences.IsShowElectronicSign;
                state.enableUploadFeature = accountPreferences.EnableUploadFeature;
                state.showAdditionalDepartmentInformationInEmployee = accountPreferences.ShowAdditionalDepartmentInformationInEmployee;
                state.isShowEmployeeNameWithCode = accountPreferences.IsShowEmployeeNameWithCode;
                state.isShowDisableEmployeesInReport = accountPreferences.IsShowDisableEmployeesInReport;
                state.restrictEntryWithinTaskDateRange = accountPreferences.RestrictEntryWithinTaskDateRange;
                state.scheduledEmailSendTime = accountPreferences.ScheduledEmailSendTime;
                state.accountSessionTimeout = accountPreferences.AccountSessionTimeout;
                state.decimalPlaces = accountPreferences.DecimalPlaces;
                state.pageSize = accountPreferences.PageSize;
                state.fromEmailAddressDisplayName = accountPreferences.FromEmailAddressDisplayName;
                state.fromEmailAddress = accountPreferences.FromEmailAddress;
                state.userInterfaceLanguage = accountPreferences.UserInterfaceLanguage;
                state.showEmployeeNameBy = accountPreferences.ShowEmployeeNameBy;
                state.isCompanyOwnLogo = accountPreferences.IsCompanyOwnLogo == null ? false : accountPreferences.IsCompanyOwnLogo;

                state.employeeSegregationType = accountPreferences.EmployeeSegregationType;

                state.showProjectNameInInvoiceReport = accountPreferences.ShowProjectNameInInvoiceReport;
                state.showBillingRateInInvoiceReport = accountPreferences.ShowBillingRateInInvoiceReport;
                state.showEntryDateInInvoiceReport = accountPreferences.ShowEntryDateInInvoiceReport;
                state.showEmployeeNameInInvoiceReport = accountPreferences.ShowEmployeeNameInInvoiceReport;
                state.showWorkTypeInInvoiceDescription = accountPreferences.ShowWorkTypeInInvoiceDescription;
                state.roundOffValueInInvoice = accountPreferences.RoundOffValueInInvoice;
                state.resetInvoiceNo = accountPreferences.ResetInvoiceNo;
                state.invoiceNoPrefix = accountPreferences.InvoiceNoPrefix;
                state.invoiceBillingTypeId = accountPreferences.InvoiceBillingTypeId;
                state.invoiceFooter = accountPreferences.InvoiceFooter;

                state.showProjectNameInTask = accountPreferences.ShowProjectNameInTask;
                state.showClientNameInTask = accountPreferences.ShowClientNameInTask;
                state.insertDefaultTaskNameInProject = accountPreferences.InsertDefaultTaskNameInProject;
                state.defaultTaskName = accountPreferences.DefaultTaskName;
                state.isAutoCompleteTask = accountPreferences.IsAutoCompleteTask;
                state.allocationHoursInProjectTaskTeam = accountPreferences.AllocationHoursInProjectTaskTeam;
                state.accountIdsForAllocationHours = accountPreferences.AccountIdsForAllocationHours;
                state.sortTaskBy = accountPreferences.SortTaskBy;

                state.autoGenerateProjectCode = accountPreferences.AutoGenerateProjectCode;
                state.allocationHoursInProjectTeam = accountPreferences.AllocationHoursInProjectTeam;
                state.enableGanttChart = accountPreferences.EnableGanttChart;
                state.showCompletedProjectInProjectList = accountPreferences.ShowCompletedProjectInProjectGrid;
                state.showClientDepartmentInProject = accountPreferences.ShowClientDepartmentInProject;
                state.includeCurrentYearInProjectCode = accountPreferences.IncludeCurrentYearInProjectCode;
                state.automaticallyIncludeAdminitratorInProjectTeam = accountPreferences.AutomaticallyIncludeAdminitratorInProjectTeam;
                state.showDisableProjectInReport = accountPreferences.ShowDisableProjectInReport;
                state.isProjectTemplateMandatory = accountPreferences.IsProjectTemplateMandatory;
                state.projectCodePrefix = accountPreferences.ProjectCodePrefix;
                state.showAdditionalProjectInformationType = accountPreferences.ShowAdditionalProjectInformationType;

                state.showTimeOffInTimesheet = accountPreferences.ShowTimeOffInTimesheet;
                state.showProjectForTimeOff = accountPreferences.ShowProjectForTimeOff;
                state.hideTimeOffHoursInformation = accountPreferences.HideTimeOffHoursInformation;
                state.isShowTimeOffInDays = accountPreferences.IsShowTimeOffInDays;
                state.isShowTimeOffPoliciesInDays = accountPreferences.IsShowTimeOffPoliciesInDays;
                state.isTimeOffStatusEditMode = accountPreferences.IsTimeOffStatusEditMode;
                state.showTimeOffTypesBy = accountPreferences.ShowTimeOffTypesBy;

                state.showClientInExpenseSheet = accountPreferences.ShowClientInExpenseSheet;
                state.showTaskInExpenseSheet = accountPreferences.ShowTaskInExpenseSheet;
                state.expenseApprovalTypeBy = accountPreferences.ExpenseApprovalTypeBy;
                state.expenseSheetPrintFooter = accountPreferences.ExpenseSheetPrintFooter;

                state.showClockStartEnd = accountPreferences.ShowClockStartEnd;
                //state.showClientInTimesheet = accountPreferences.ShowClientInTimesheet;
                state.isAllowOverlappingTimeEntries = accountPreferences.IsAllowOverlappingTimeEntries;
                state.showDescriptionInWeekView = accountPreferences.ShowDescriptionInWeekView;
                state.showCompletedProjectsInTimeSheet = accountPreferences.ShowCompletedProjectsInTimeSheet;
                state.showCompletedTasksInTimeSheet = accountPreferences.ShowCompletedTasksInTimeSheet;
                //state.showWorkTypeInTimeSheet = accountPreferences.ShowWorkTypeInTimeSheet;
               // state.showCostCenterInTimeSheet = accountPreferences.ShowCostCenterInTimeSheet;
                state.showClientInTimesheet = accountPreferences?.ShowClientInTimesheet;
                state.showCostCenterInTimeSheet = accountPreferences?.ShowCostCenterInTimeSheet;
                state.showWorkTypeInTimeSheet = accountPreferences?.ShowWorkTypeInTimeSheet;
                state.isCostCenterMandatory = accountPreferences.IsCostCenterMandatory;
                state.showCopyTimesheetButton = accountPreferences.ShowCopyTimesheetButton;
                state.showCopyActivitiesButtonInTimesheet = accountPreferences.ShowCopyActivitiesButtonInTimesheet;
                state.enableOfflineTimesheet = accountPreferences.EnableOfflineTimesheet;
                state.enableTimerInTimesheet = accountPreferences.EnableTimerInTimesheet;
                state.showPercentageInTimesheet = accountPreferences.ShowPercentageInTimesheet;
                state.calculateTaskPercentageAutomatically = accountPreferences.CalculateTaskPercentageAutomatically;
                state.defaultProjectTaskSelectionInTimesheet = accountPreferences.DefaultProjectTaskSelectionInTimesheet;
                state.autoResizeTimesheet = accountPreferences.AutoResizeTimesheet;
                state.numberOfBlankRowsInTimeEntry = accountPreferences.NumberOfBlankRowsInTimeEntry;
                state.numberOfBlankRowsInTimeOff = accountPreferences.NumberOfBlankRowsInTimeOff;
                state.timesheetOverduePeriods = accountPreferences.TimesheetOverduePeriods;
                state.showClockStartEndBy = accountPreferences.ShowClockStartEndBy;
                state.timeEntryHoursFormatId = accountPreferences.TimeEntryHoursFormatId;
                state.decimalFormat = getTimeEntryHoursFormat(accountPreferences.TimeEntryHoursFormatId) == 'Time' ? false : true;
                state.timeEntryFormat = accountPreferences.TimeEntryFormat;
                state.showAdditionalTaskInformationType = accountPreferences.ShowAdditionalTaskInformationType;
                state.defaultTimeEntryMode = accountPreferences.DefaultTimeEntryMode;
                state.timesheetSort = accountPreferences.TimesheetSort;
                state.showCostCenterInTimesheetBy = accountPreferences.ShowCostCenterInTimesheetBy;
                state.timesheetApprovalTypeBy = accountPreferences.TimesheetApprovalTypeBy;
                state.timesheetPrintFooter = accountPreferences.TimesheetPrintFooter;
                state.timesheetSubmissionMessage = accountPreferences.TimesheetSubmissionMessage;

                state.enableGoogleAuthentication = accountPreferences.EnableGoogleAuthentication;
                state.enablePasswordComplexity = accountPreferences.EnablePasswordComplexity;
                state.passwordExpiryPeriod = accountPreferences.PasswordExpiryPeriod;
                state.enableSingleSignOnSSO = accountPreferences.EnableSingleSignOnSSO;
                state.usingSingleSignOnWith = accountPreferences.UsingSingleSignOnWith;
                state.sAMLSSOURL = accountPreferences.SAMLSSOURL;
                state.remoteLogoutURL = accountPreferences.RemoteLogoutURL;
                state.x509Certificate = accountPreferences.X509Certificate;

                state.showFilterInformationOnExport = accountPreferences.ShowFilterInformationOnExport;

                state.cultureInfoName = accountPreferences.CultureInfoName;
                state.currencySymbol = accountPreferences.CurrencySymbol;
                state.version = accountPreferences.Version;
                state.accountBaseCurrencyId = accountPreferences.AccountBaseCurrencyId;
                state.accountReimbursementCurrencyId = accountPreferences.AccountReimbursementCurrencyId;
                //state.showEmployeeProfilePicture = accountPreferences.ShowEmployeeProfilePicture == null ? false : accountPreferences.ShowEmployeeProfilePicture;
                state.showEmployeeProfilePicture = accountPreferences.IsShowEmployeeProfilePicture ? true : false;
                state.googleAppsDomain = accountPreferences.GoogleAppsDomain;
                state.showProjectInTimesheet = accountPreferences.ShowProjectInTimesheet;
                state.defaultCurrencyId = accountPreferences.DefaultCurrencyId;
                state.systemTimeEntryHoursFormat = accountPreferences.SystemTimeEntryHoursFormat;
                state.assignTimeOffPolicyIn = accountPreferences.AssignTimeOffPolicyIn;
                state.assignWorkingDayTypeIn = accountPreferences.AssignWorkingDayTypeIn;
                state.isEmailVerified = accountPreferences.IsEmailVerified;
                state.CurrentCultureDateFormat = determineCultureFormat(accountPreferences.CultureInfoName);
                state.allowZeroHoursInTimesheet = accountPreferences.AllowZeroHoursInTimesheet == null ? false : accountPreferences.AllowZeroHoursInTimesheet;
                state.showTemplateInTimesheet = accountPreferences.ShowTemplateInTimesheet == null ? false : accountPreferences.ShowTemplateInTimesheet;
                state.AccountIdsForGoogleCalendar = accountPreferences.AccountIdsForGoogleCalendar;
                state.AccountIdsForOutlookCalendar = accountPreferences.AccountIdsForOutlookCalendar;
                state.allowMoveTask = accountPreferences.AllowMoveTask == null ? false : accountPreferences.AllowMoveTask;
                state.HighlightTimeEntriesBy = !accountPreferences.HighlightTimeEntriesBy ? "Task" : accountPreferences.HighlightTimeEntriesBy;
                state.calendarStartDay = GetCalendarStartDay(accountPreferences.CalendarWeekStartDay);
                state.ProfileTimeZoneIANA  = accountPreferences.ProfileTimeZoneIANA;
                state.AccountEmployeeDashboardId = accountPreferences.AccountEmployeeDashboardId;
                state.OpenInNewTab  = accountPreferences.OpenInNewTab;
                state.ShowAdvanceBoard = accountPreferences.ShowAdvanceBoard;
                state.IsTimesheetApprovalReasonMandatory = accountPreferences.IsTimesheetApprovalReasonMandatory;
                state.IsTimesheetChangelogEnabled = accountPreferences.IsTimesheetChangelogEnabled;
                if (typeof chrome !== 'undefined' && chrome.storage && chrome.storage.local) {
                chrome.storage.local.set({
                showClientInTimesheet: accountPreferences?.ShowClientInTimesheet,
                showCostCenterInTimeSheet: accountPreferences?.ShowCostCenterInTimeSheet,
                showWorkTypeInTimeSheet: accountPreferences?.ShowWorkTypeInTimeSheet,
                timeZoneId: accountPreferences?.TimeZoneId
            });
        }

            })
            .addCase(getGlobalAccountPreferenceDataAsync.rejected, (state) => {

            })
            .addCase(getManageTerminologyAsync.pending, (state) => {

            })
            .addCase(getManageTerminologyAsync.fulfilled, (state, { payload }) => {
                state.manageTerminologyList = payload.Data;
            })
            .addCase(getManageTerminologyAsync.rejected, (state) => {

            })
            .addCase(GetCalendarEventsForNotification.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(GetCalendarEventsForNotification.fulfilled, (state, { payload }) => {
                if (payload?.Data) {
                    localStorage.setItem("Notification", JSON.stringify(payload.Data));
                }
                state.notificationEvents = payload?.Data || [];
                state.isLoading = false;
            })
            .addCase(GetCalendarEventsForNotification.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(getEmployeeProfileSettingAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getEmployeeProfileSettingAsync.fulfilled, (state, action) => {
                let finalObj;
                if (NODE_ENV === "production") {
                    finalObj = action.payload.hasOwnProperty("d") ? JSON.parse(action.payload.d) : JSON.parse(action.payload);
                } else {
                    finalObj = action.payload;
                }
                const { AccountId, AccountEmployeeId, AccountRoleId, CurrentCultureDateFormat, CustomFieldsTemplate, AccessToken, EmployeeName, EmployeeInitials, DecimalFormat, HoursPerDay, EmployeeNameWithCode } = finalObj;
                if (state.sessionAccountEmployeeId == 0) {
                    state.sessionAccountEmployeeId = AccountEmployeeId;
                }
                // state.CurrentCultureDateFormat = CurrentCultureDateFormat;
                state.sessionAccountId = AccountId;
                state.accountRoleId = AccountRoleId;
                state.accessToken = AccessToken;
                state.employeeName = EmployeeName;
                state.shortName = EmployeeInitials;
                state.customFieldsTemplate = CustomFieldsTemplate;
                state.decimalFormat = DecimalFormat;
                state.hoursPerDay = HoursPerDay;
                state.employeeNameWithCode = EmployeeNameWithCode;
                localStorage.setItem('accessToken', AccessToken);
                localStorage.setItem('accountEmployeeId', AccountEmployeeId);
            })
            .addCase(getEmployeeProfileSettingAsync.rejected, (state) => {
                state.status = 'failed'
            })
            ///////
            // .addCase(getEmployeeMoveToOldAsync.pending, (state) => {
            //     state.status = 'loading';
            // })
            // .addCase(getEmployeeMoveToOldAsync.fulfilled, (state, action) => {
            //     let finalObj;
            //     if (NODE_ENV === "production") {
            //         finalObj = action.payload.hasOwnProperty("d") ? JSON.parse(action.payload.d) : JSON.parse(action.payload);
            //     } else {
            //         finalObj = action.payload;
            //     }
            //     console.log("ab bol yaha se to", finalObj)
            // })
            // .addCase(getEmployeeMoveToOldAsync.rejected, (state) => {
            //     state.status = 'failed'
            // })
            ///////
            .addCase(getAccountFeatureAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountFeatureAsync.fulfilled, (state, action) => {
                let tempAccountFeature = <any>[];
                action.payload.AccountFeatures.map((item: any) => {
                    let obj = {
                        "Id": item.SystemFeatureId,
                        "Name": getAccountFeature(item.SystemFeatureId)
                    }
                    tempAccountFeature.push(obj)
                });
                state.accountFeatureList = tempAccountFeature;
                state.masterAccountRoleId = action.payload.AccountRoles.length > 0 ? action.payload.AccountRoles[0].MasterAccountRoleId : 0;
            })
            .addCase(getAccountFeatureAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getLicenseActivationAndPageLoadDataAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getLicenseActivationAndPageLoadDataAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //console.log("getLicenseActivationAndPageLoadDataAsync:",payload);
                if (Object.keys(payload.Data).length === 0) {
                    state.licenseActivationList = [];
                } else {
                    state.licenseActivationList = payload.Data;
                    state.licenseActivationList.map((item: any) => {
                        item.MachineId = payload.machineId
                    });
                    state.selectedRecord = state.licenseActivationList[0];
                    state.isValidLicenseActivation = payload.isValidLicenseActivation;
                    state.expiryDateLicense = payload.expiryDateLicense;
                    state.isFreeAccount = payload.isFreeAccount;
                    state.rowscount = payload.rowscount;
                    state.numberOfUsersAllowed = payload.numberOfUsersAllowed;
                    state.DISABLE_LICENSE = payload.DISABLE_LICENSE;
                    state.applicationMode = payload.applicationMode;
                    state.isFreeLiteVersion = payload.isFreeLiteVersion;
                    state.isPaidCustomerLicenseExpired = payload.isPaidCustomerLicenseExpired;
                    state.isHostedPaidCustomerLicenseExpired = payload.isHostedPaidCustomerLicenseExpired;
                    state.cancellationURL = payload.cancellationURL;
                    state.IsHostedPaidCustomer = payload.IsHostedPaidCustomer;
                    state.SelectedCurrentHostedPackage = payload.SelectedCurrentHostedPackage;
                    state.IsUpgradeExistingPlan = payload.IsUpgradeExistingPlan;
                    state.PackagesData = payload.PackagesData;
                }
                // state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getLicenseActivationAndPageLoadDataAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

        // .addCase(getCustomFieldTemplateByMasterEntityTypeIdAsync.pending, (state) => {
        //     state.status = 'loading';
        // })
        // .addCase(getCustomFieldTemplateByMasterEntityTypeIdAsync.fulfilled, (state, action) => {
        //     state.status = 'idle';
        //     state.customFieldsList = action.payload;
        // })
        // .addCase(getCustomFieldTemplateByMasterEntityTypeIdAsync.rejected, (state) => {
        //     state.status = 'failed'
        //     state.customFieldsList = [];
        // })
    }
})
export const { checkedshowAdminPagesState, UncheckedshowAdminPagesState, UpdateCurrentPopupId, updatePageIdState, updateCustomMenuList, updatePageSize, updateAllowZeroHoursInTimesheet, updateGoogleCalendarAutoSync, updateGoogleCalendarTimesheetAutoSync, updateGoogleCalendarTaskAutoSync, updateGoogleCalendarTimesheetManualSync, updateGoogleCalendarTaskManualSync, updateOutlookCalendarAutoSync, updateOutlookCalendarTaskAutoSync, updateOutlookCalendarTaskManualSync, updateOutlookCalendarTimesheetAutoSync, updateOutlookCalendarTimesheetManualSync, updateEmployeeProfileSettingOnDev, updateSubMenusForDisplay,setPageId,updatePageSizeTeam,UpdateEmployeePermissions, UpdateAccountEmployeeDashboardId, UpdateStateOpenInNewTab , UpdateStateShowAdvanceBoard} = globalSlice.actions
export const absenceTypeStateClass = (state: RootState) => state.globalState
export default globalSlice.reducer